import { Component } from '@angular/core';
import { VideoControlsComponent } from '../video-controls/video-controls.component';

@Component({
  selector: 'studio-time-indicator',
  templateUrl: './time-indicator.component.html',
  styleUrls: ['./time-indicator.component.scss'],
})
export class TimeIndicatorComponent {
  constructor(protected videoControls: VideoControlsComponent) {}
}
